// src/i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './lang/en.json';
import es from './lang/es.json';

Vue.use(VueI18n);

const messages = {
  en,
  es
};

function getInitialLocale() {
  if (typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem('locale');
    if (stored === 'en' || stored === 'es') {
      return stored;
    }
  }
  if (typeof navigator !== 'undefined') {
    const browserLocale = navigator.language.slice(0, 2);
    if (browserLocale === 'en' || browserLocale === 'es') {
      return browserLocale;
    }
  }
  return 'en';
}

const i18n = new VueI18n({
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
});

export default i18n;
